import { useContext } from "react";
import { HeaderContext } from "./header";

export const useHeader = () => ( useContext(HeaderContext));

export default useHeader;